import { ChatAppResponse } from "../../api";

export type HistoryMetaData = {
    id: string;
    title: string;
    timestamp: number;
    patient_id?: string;
    total_tokens?: number;
    estimated_cost?: number;
    query_count?: number;
    total_backend_ms?: number;
};
export type Answers = [user: string, response: ChatAppResponse][];

export const enum HistoryProviderOptions {
    None = "none",
    IndexedDB = "indexedDB",
    CosmosDB = "cosmosDB"
}

export interface IHistoryProvider {
    getProviderName(): HistoryProviderOptions;
    resetContinuationToken(): void;
    getNextItems(count: number, idToken?: string, userId?: string): Promise<HistoryMetaData[]>;
    getItem(id: string, idToken?: string, userId?: string): Promise<Answers | null>;
    deleteItem(id: string, idToken?: string, userId?: string): Promise<void>;
    addItem(id: string, answers: Answers, idToken?: string, entraUserId?: string, ehrUserId?: string, patientId?: string): Promise<void>;
}
